function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.27.1l12.48 7.12a.49.49 0 01-.19.88l-4.46 1 4.28 7.41a.75.75 0 01.07.57l-.1.37a.75.75 0 01-.35.45l-3.43 2a.75.75 0 01-.38.1H9l-.33-.12a.77.77 0 01-.46-.35l-4.28-7.41L.87 15.5a.5.5 0 01-.54.13.5.5 0 01-.33-.47V.82A.77.77 0 01.4.17L.52.1A.69.69 0 01.89 0a.75.75 0 01.38.1zm5.126 7.786A.5.5 0 016.75 7.6L9.37 7 2 2.83v8.45l1.84-2.02a.51.51 0 01.81.08l4.85 8.34 1.73-1-4.81-8.34a.5.5 0 01-.024-.454z"
});

var SvgMouseCursorOutlined = function SvgMouseCursorOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    fill: "#868E96"
  }, props), _ref);
};

export default SvgMouseCursorOutlined;